export default __webpack_public_path__ + "static/media/rajab_1.59b632e5.jpg";